import {ProductCard} from "@components/product";
import { Button } from '@components/ui'
import Link from "next/link";

const ShopFoldContent = (
  {
    Title,
    CTA,
    Description,
    FeaturedProduct1,
    FeaturedProduct2,
    FeaturedProduct3
  }: any) => {
  return (
    <div className="md:flex-wrap lg:flex-nowrap md:flex flex-row md:gap-0 lg:gap-4 mb-4">
      {
        FeaturedProduct1 && <div className="md:w-2/3 lg:w-1/2">
          <ProductCard
            key={FeaturedProduct1.id}
            product={FeaturedProduct1}
            imgProps={{
              alt: '', // todo
              width: 1080,
              height: 1080,
              priority: true,
            }}/>
        </div>
      }
      <div className="md:w-1/3 lg:w-1/4">
        <div className="p-4 text-white bg-dark h-full flex flex-col bg-pattern">
          <h2 className="uppercase mb-4">{Title}</h2>
          <p className="mb-4 md:mb-auto">{Description}</p>
          {
            CTA && CTA.href && CTA.label ?
              CTA.isExternal ?
                <Button Component={'a'} href={CTA.href}>{CTA.label}</Button> :
                <Link href={CTA.href}><Button>{CTA.label}</Button></Link>: null
          }

        </div>

      </div>
      <div className="md:w-full lg:w-1/4 flex md:flex-row lg:flex-col gap-4 lg:gap-0 my-4 lg:my-0">
        {
          FeaturedProduct2 &&
          <div className="w-1/2 lg:w-full lg:aspect-square">
            <ProductCard
              key={FeaturedProduct2.id}
              product={FeaturedProduct2}
              imgProps={{
                alt: '', // todo
                width: 540,
                height: 540,
                priority: true,
              }}/>
          </div>
        }
        {
          FeaturedProduct3 && <div className="w-1/2 lg:w-full lg:aspect-square">
            <ProductCard
              key={FeaturedProduct3.id}
              product={FeaturedProduct3}
              imgProps={{
                alt: '', // todo
                width: 540,
                height: 540,
                priority: true,
              }}/>
          </div>
        }

      </div>
    </div>
  )
}

ShopFoldContent.defaultProps = {};

export default ShopFoldContent;
